import React from 'react';
import PropTypes from 'prop-types';
import { isAvailableToAllIncentive } from 'site-modules/shared/utils/incentives/electric-car-incentives';

export function SupportCopy({ primary = false, compatibleIncentiveIds = [], programType = '' }) {
  if (isAvailableToAllIncentive({ primary, compatibleIncentiveIds, programType })) {
    return <div className="text-blue-50 medium fst-italic fw-normal">Available to all</div>;
  }
  return <div className="text-cool-gray-40 medium fst-italic fw-normal">Restrictions apply</div>;
}

SupportCopy.propTypes = {
  primary: PropTypes.bool,
  compatibleIncentiveIds: PropTypes.arrayOf(PropTypes.string),
  programType: PropTypes.string,
};
